import React from "react";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import routes from "./components/navigation/router/routes";
import configuredStore from "./store/configuredStore";
import { Spin } from "antd";
import { ErrorBoundary } from "react-error-boundary";
import CustomErrorBoundary from "./components/navigation/CustomErrorBoundary";
import { App as Application } from "antd";

const { store, persistor } = configuredStore();
const router = createBrowserRouter(routes);

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate
        loading={
          <Spin
            spinning={true}
            tip="Please wait for a moment..."
            fullscreen
            size="large"
          />
        }
        persistor={persistor}
      >
        <ErrorBoundary FallbackComponent={CustomErrorBoundary}>
          <Application
            notification={{
              stack: false,
            }}
          >
            <RouterProvider router={router} />
          </Application>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  );
};

export default App;
